import classnames from "classnames";
import { useEffect, useState } from "react";
import styles from "../styles/Loading.module.scss";
import IconSpiner from "../svgs/icon_spinner.svg";

// showStartにミリ秒を指定すると表示開始を遅らせることができる。
// 一瞬だけローディングがでて微妙という場合に使う想定
export default function Loadingprogressbar({ fixed, showStart }) {
  const [show, setShow] = useState(showStart ? false : true);

  useEffect(() => {
    let timeoutId;
    if (showStart) {
      timeoutId = setTimeout(() => setShow(true), showStart);
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  if (!show) return null;

  return (
    <div className={classnames(styles.wrapper, { [styles.fixed]: fixed })}>
      <div className={styles.loaderCont}>
        <IconSpiner className={styles.fillMainColor} />
      </div>
      <div className={styles.progressbarContainer}>
        <div className={styles.progressbar}> </div>
        <div className={styles.progressbarIcon}> </div>
      </div>
      <div className={styles.text}>
        <p>ここからはメンバーズIDの手続きになります</p>
        <p>(スカパー！メンバーズのサイトに遷移します)</p>
      </div>
    </div>
  );
}
